import { render, staticRenderFns } from "./NewsCM.vue?vue&type=template&id=fb2bf2b6&scoped=true&"
import script from "./NewsCM.vue?vue&type=script&lang=js&"
export * from "./NewsCM.vue?vue&type=script&lang=js&"
import style0 from "./NewsCM.vue?vue&type=style&index=0&id=fb2bf2b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2bf2b6",
  null
  
)

export default component.exports